import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';

export const PopUp = 'https://baseavaar2.s3.amazonaws.com/campaign_details.webp';

const padding = '100px';
const xDimension = `calc(100vw - ${padding})`;
const maxXDimension = '1500px';
const yDimension = `calc(100vh - ${padding})`;

export const marketingPopUpStyles = {
	modalWrapper: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',

		outline: 'none',
	},
	modalBody: {
		width: `min(${maxXDimension}, min(${xDimension}, 1.86 * ${yDimension}))`,
		height: `min(calc(${maxXDimension} * 0.53), calc(0.53 * min(${xDimension}, 1.86 * ${yDimension})))`,

		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',

		position: 'relative',
	},
	crossButton: {
		position: 'absolute',
		top: 0,
		right: 0,

		minWidth: 'unset',
		padding: '8px',
		borderRadius: '50%',

		backgroundColor: 'colors.dark1',

		transform: 'translate(100%, -100%)',
		zIndex: 1,

		'& svg': {
			stroke: colorPalette.light2,

			height: '24px',
			width: 'auto',
		},

		'&:hover': { backgroundColor: 'colors.dark1' },
	},
	MarketingPopUp: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',

		position: 'relative',

		'& img': {
			height: 'auto',
			width: '100%',

			objectFit: 'contain',
		},
	},
};
